import { table } from "console";

const config = {
  env: process.env.REACT_APP_ENV || "unkown",
  appVersion: process.env.REACT_APP_VERSION || "-1",
  apiUrl: process.env.REACT_APP_API_URL || "",
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL || "",
  keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "",
  keycloakClientSecret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET || "",
  authRedirectUrl: process.env.REACT_APP_AUTH_REDIRECT_URL || "",
  roles: ["sdlp-user", "pilote", "sdlp-superadmin", "performer"] as const,
  eventStatus: {
    DECLARE: {
      label: "En attente de pilote",
      color: "var(--magenta-light)",
    },
    DISPATCHE: {
      label: "En attente d'analyse",
      color: "var(--blue-6)",
    },
    ANALYSE_EFFECTUEE: {
      label: "En attente d'actions",
      color: "var(--magenta)",
    },
    TRAITEMENT_PILOTE: {
      label: "Plan d'action en cours",
      color: "var(--orange-1)",
    },
    DEMANDE_VALIDATION: {
      label: "En attente de validation",
      color: "var(--blue-primary)",
    },
    REFUSE: {
      label: "RefusÃ©",
      color: "var(--red-1)",
    },
    CLOTURE: {
      label: "CloturÃ©",
      color: "var(--green-1)",
    },
  },
  actionStatus: {
    CREATED: {
      label: "En attente d'affectation",
      color: "var(--magenta-light)",
    },
    AFFECTED: {
      label: "En attente de rÃ©alisation",
      color: "var(--magenta)",
    },
    PERFORMED: {
      label: "RÃ©alisÃ©e",
      color: "var(--blue-6)",
    },
    VALIDATED: {
      label: "ValidÃ©e",
      color: "var(--green-1)",
    },
    REFUSED: {
      label: "RefusÃ©e",
      color: "var(--red-1)",
    },
    DEMANDE_VALIDATION: {
      label: "Validation demandÃ©e",
      color: "var(--orange-1)",
    },
  },
  auditStatus: {
    CREATED: {
      label: "En cours",
      color: "var(--orange-1)",
    },
    VALIDATED: {
      label: "ValidÃ©e",
      color: "var(--green-1)",
    },
  },
  projectStatus: {
    DECLARE: {
      label: "En cours",
      color: "var(--orange-1)",
    },
    CLOTURE: {
      label: "ClÃ´turÃ©",
      color: "var(--green-1)",
    },
    ARCHIVED: {
      label: "ArchivÃ©",
      color: "#8c8c8c",
    },
  },
  actionCauseTypes: [
    {
      value: "CORRECTIF",
      label: "Correctif",
    },
    {
      value: "PREVENTIF",
      label: "Preventif",
    },
  ],
  tablePageSize: 10, // results per page
  tableSearchDebounceTime: 1200, // ms,
};

if (process.env.NODE_ENV === "development") {
  console.log("config");
  console.log(config);
}

export default config;
